import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BannerMode, BaseViewComponent, IconItem, StatusKind } from '@sb/library/base';

@Component({
    selector: 'lib-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss']
})
export class BannerComponent extends BaseViewComponent implements OnInit {
    @Input() isDismissable: boolean = true;
    @Input() kind: StatusKind = StatusKind.Default;
    @Input() mode: BannerMode = BannerMode.Stacked;
    @Input() startExpanded: boolean = false;
    @Input() qaTag: string = '';

    @Output() dismissButtonClicked = new EventEmitter<boolean>();

    private _showBanner: boolean = true;

    DismissBanner() {
        this._showBanner = false;
        this.dismissButtonClicked.emit(true);
    }

    ShowBanner() {
        this._showBanner = true;
    }

    get showBanner(): boolean {
        return this._showBanner;
    }
}
